const TRANSIENT_MESSAGE_PATTERNS = [
  "timeout",
  "timed out",
  "network",
  "econnreset",
  "econnrefused",
  "temporarily unavailable",
  "service unavailable",
  "storage",
  "quota exceeded",
  "out of memory",
  "failed to fetch",
  "rate limit",
  "too many requests",
  "render",
  "writefile",
  "blob",
];

const TRANSIENT_HTTP_STATUSES = new Set([408, 429, 500, 502, 503, 504]);

export function isTransientError(error) {
  if (error?.isTransient === true) {
    return true;
  }

  if (error?.isTransient === false) {
    return false;
  }

  if (error?.name === "ApiError" && typeof error.status === "number") {
    return TRANSIENT_HTTP_STATUSES.has(error.status);
  }

  if (error instanceof DOMException) {
    if (error.name === "AbortError") {
      return false;
    }
    return error.name === "NetworkError";
  }

  if (error instanceof TypeError && error.message.toLowerCase().includes("fetch")) {
    return true;
  }

  if (error instanceof Error) {
    const normalized = error.message.toLowerCase();
    return TRANSIENT_MESSAGE_PATTERNS.some((pattern) => normalized.includes(pattern));
  }

  return false;
}
